import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { getHistory } from "../../../providers/consultsProvider";
import { formatDate, millisecondsToMinutes } from "../../utils/formatTime";

const Historico = ({ user }) => {
  const [consultsList, setConsultsList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number.MAX_VALUE);

  const loadItems = async () => {
    if (page > limit) return;
    const result = await getHistory(user._id, user.token, page);
    if (result.error) {
      console.log(result);
      return;
    }
    setConsultsList([...consultsList, ...result.docs]);
    setPage(page + 1);
    return result;
  };

  useEffect(() => {
    const getData = async () => {
      const result = await loadItems();
      setLimit(result.pages);
    };
    getData();
  }, []);

  useEffect(() => {
    window.onscroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop ===
        document.documentElement.offsetHeight
      ) {
        loadItems();
      }
    };
    return () => {
      window.onscroll = null;
    };
  });

  return (
    <div>
      <Table responsive>
        <thead>
          <tr>
            <th>Data</th>
            {/* <th>Descrição</th> */}
            <th>{user.isProfessional ? "Consultado" : "Consultor"}</th>
            <th>Tempo</th>
            {/* <th>Avaliação</th> */}
            {/* <th>Forma de pagamento</th> */}
            {/* <th>Total</th> */}
          </tr>
        </thead>
        <tbody>
          {consultsList.map(consult => (
            <tr key={consult._id}>
              <th scope="row">{formatDate(consult.createdAt)}</th>
              <td>
                {user.isProfessional
                  ? `${consult.customerId.firstName} ${consult.customerId.lastName}`
                  : `${consult.professionalId.firstName} ${consult.professionalId.lastName}`}
              </td>
              <td className="ml-2">
                {consult.status === "finished"
                  ? `${millisecondsToMinutes(
                      new Date(consult.endTime) - new Date(consult.beginTime)
                    )} m`
                  : null}
              </td>
              {/* <td>{consult.payment ? `C$ ${consult.payment}` : null}</td> */}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default Historico;
